import React from 'react'

type Props = {
  className?: string
  fill?: string
  size?: string
}

const Bank = ({ className, fill = '#98A1B2', size = '24' }: Props) => (
  <svg
    className={className}
    fill={fill}
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M4.89474 10.5V17.5H7.73684V10.5H4.89474ZM10.5789 10.5V17.5H13.4211V10.5H10.5789ZM3 22.5H21V19.5H3V22.5ZM16.2632 10.5V17.5H19.1053V10.5H16.2632ZM12 1.5L3 6.5V8.5H21V6.5L12 1.5Z' />
  </svg>
)

export default Bank
